var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cloudflare-turnstile-3f-style",attrs:{"role":"group","aria-label":"CAPTCHA-verifikation"}},[_c('div',{ref:"container",staticClass:"cf-turnstile"})])
}
var staticRenderFns = []

export { render, staticRenderFns }